Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    viewports = _STYLES$useStyles.viewports,
    boxShadows = _STYLES$useStyles.boxShadows;
  var header = {
    minHeight: 450
  };
  var headerContent = {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  };
  var proHeaderImage = {
    flex: 1
  };
  var logoImage = {
    width: '100%',
    height: '100%',
    borderRadius: 50
  };
  var logo = Object.assign({
    backgroundColor: '#FFFFFF',
    padding: spacing.normal,
    borderRadius: 50,
    width: 100,
    height: 100
  }, boxShadows.button.all);
  var nameContainer = {
    textAlign: 'center',
    paddingRight: spacing.page.padding.paddingRight,
    paddingLeft: spacing.page.padding.paddingLeft,
    marginBottom: spacing.xl
  };
  var name = {
    marginBottom: 0
  };
  if (bp.gt(viewports.mobile_l)) {
    logo.width = 140;
    logo.height = 140;
    logo.padding = spacing.l;
    logo.borderRadius = 70;
  }
  var styles = _reactNative.StyleSheet.create({
    header: header,
    headerContent: headerContent,
    logo: logo,
    logoImage: logoImage,
    proHeaderImage: proHeaderImage,
    nameContainer: nameContainer,
    name: name
  });
  return {
    styles: styles
  };
};